import Vue from 'vue'
import Vuex from 'vuex'
import Certificates from '../components/Certificates.vue';
import axios from "axios";
import VueCookies from 'vue-cookies'
import Router from "../components/Router.vue";

require('../css/catalog.css');

Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(VueCookies)

const router = Router;

const store = new Vuex.Store({
    state: {
        certificates: {},
    },
    mutations: {
        updateCertificates(state, certificates) {
            state.certificates = certificates;
        },
    },
    actions: {
        GET_CERT: (context, payload) => {
            axios.get(
                '/api/certificate',
                {
                    headers: {
                        'content-type': 'application/json; charset=utf8',
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }
            )
                .then(function (response) {
                    if (response.data.status) {
                        context.commit("updateCertificates", response.data.result);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },
    getters: {
        certificates: state => state.certificates,
    }
})

new Vue({
    router,
    store,
    render: function (h) {
        return h(Certificates);
    },
    el: '#certificates',
    data: {
    },
    components: {
        Certificates
    },
    created() {
        this.$cookies.config('30d');
        this.$store.dispatch('GET_CERT', true);
    },
    renderError (h, err) {
        return h('pre', { style: { color: 'red' }}, err.stack)
    }
});
